
	import Component from 'vue-class-component'
	import moduleStore from './store/signIn';
	import Vue from 'vue';
	import PageState from './store/state';
	import {getQueryString} from "@/utils/location";
	import {toast} from "@/utils/util";
	import {judgeDeviceType} from "@/utils/device";


	/**components**/
	@Component({})
	@moduleStore.initVuex({
		mutationNames:moduleStore.mutationNames,
		actionNames:moduleStore.actionNames
	})
	export default class signInPage extends Vue implements IvuePage<PageState>{
		state = new PageState();
		self:Vue = this;
		isAndroid= judgeDeviceType.isAndroid;
		siginText = require('./images/sigin_text.png');
		texture = require('/public/images/welfare/texture.png');
		box = require('/public/images/welfare/box.png');
		record = require('./images/record.png');
		recordGrey = require('./images/record_grey.png');
		bean = require('/public/images/welfare/bean.png');
		check=require('./images/check.png');
		bigSlam=require('./images/big_slam.png');

		totalCount : number = 0;
		pageIndex : number =1;
		signRecord :any= [];
		year = new Date().getFullYear()+'-';
		month = (new Date().getMonth()+1>9?new Date().getMonth()+1:'0'+(new Date().getMonth()+1))+'-';
		date = new Date().getDate()>9?new Date().getDate():'0'+new Date().getDate();
		today=this.year+this.month+this.date;
		loading:Boolean= false;
		finished:Boolean=false;
		nopage: number = 0;
		currentDate='';
		isVisible:boolean=false;
		signLoading:boolean=false;

		created(moduleData:IinjectDatas) {
			this.state = <PageState>moduleData.state;
			this.getTotalCounts();
			this.getSignRecords();
		}
		mounted(moduleData:IinjectDatas){

		}
       //日期是否是今天
		isToday(time){
			return new Date(time).getTime()==new Date(this.today).getTime()
		}
		//日期是否是未来的日期
		isFutureday(time){
			return new Date(time).getTime()>new Date(this.today).getTime()
		}
		//获取魔豆数
		getTotalCounts(){
			this.$http("getTotalCount").then((response:any)=>{
				this.totalCount=response.data.totalCount
			})
		}
		//获取页面内容
		getSignRecords(){
			this.loading=true;
			this.$http("getSignRecord", {pageIndex: this.pageIndex,currentDate:this.currentDate}).then(res => {
				this.loading=false;
				if(res.code==200){
					this.nopage=res.data.length;
					if(this.nopage>0){
						res.data.forEach((ele) => {
							ele.startDate = ele.startDate.slice(5).replace("-","月")+"日";
							ele.endDate = ele.endDate.slice(5).replace("-","月")+"日";
						});
						this.signRecord=[...this.signRecord,...res.data];
						this.finished = false
					}else{
						this.finished = true;
					}
				}else{
					toast(res.message)
					this.finished=true
					this.loading=false;
					this.pageIndex = 0
				}
			})
		}
		upLoadData() {
			this.pageIndex++;
			this.loading = true;
			this.finished = false;
			this.getSignRecords();
		}
// 点击签到
		signs(item,index){
			this.signLoading=true;
			//只能签到今天的限制。
			if(!this.isToday(item.date)){
			  return;
			}

			let data={
				obtainCount:item.beanCount,
				signDate:item.date
			}
			this.$http("sign", data).then(res => {
				this.signLoading=false;
				if(res.code==200){
					this.totalCount = this.totalCount+item.beanCount;
					this.signRecord.forEach((res2,key)=>{
						if(key==index){//点击的天所在的周
							res2.isFullSign=res.data.isFullSign
							res2.cards.forEach(res1=>{//点击天数据更新
								if(res1.date==item.date){
									res1.continuousCount=res.data.continuousCount;

								}
							})
						}
					})
                    this.$set(this.signRecord,index,this.signRecord[index])
					this.$toast("签到成功");

					//测试数据。否则不能签到今天之后的日子，后面删除
					// this.currentDate = item.date;
					// this.pageIndex=1;
					// this.signRecord=[];
					// this.getSignRecords();
					// console.log("signRecord",this.signRecord)
				}else{
					this.$toast(res.message)
				}
			})
		}
		//跳转去活动规则和兑换记录
		toPath(path){
			this.$router.push({path:path,query:{wwid:getQueryString('wwid')}})
		}
		// setChooseValue(event){
		// 	this.currentDate=this.getYMDHMS(event)
		// 	this.isVisible=false;
		// 	this.pageIndex=1;
		// 	this.loading = true;
		// 	this.finished = false;
		// 	this.signRecord=[];
		// 	this.getSignRecords();
		// 	console.log("--",event,this.currentDate);
		// }
		// //把标准时间改成年-月-日
		// getYMDHMS (timestamp) {
		// 	let time: Date = new Date(timestamp)
		// 	let year: any = time.getFullYear()
		// 	let month: any = time.getMonth() + 1
		// 	let date: any = time.getDate()
		//
		// 	if (month < 10) { month = '0' + month }
		// 	if (date < 10) { date = '0' + date }
		//
		// 	return year + '-' + month + '-' + date
		// }
	}